import { render, staticRenderFns } from "./newpassword.vue?vue&type=template&id=1a3c52c2"
import script from "./newpassword.vue?vue&type=script&lang=js"
export * from "./newpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3c52c2')) {
      api.createRecord('1a3c52c2', component.options)
    } else {
      api.reload('1a3c52c2', component.options)
    }
    module.hot.accept("./newpassword.vue?vue&type=template&id=1a3c52c2", function () {
      api.rerender('1a3c52c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/auth/newpassword.vue"
export default component.exports